<h1>REGOLAMENTI</h1>
<div class="toptext">
	<p>
		Questa pagina contiene i regolamenti dell'Associazione per le relazioni con <i>Soci</i> ed <i>Enti e
			Aziende</i>.
	</p>
</div>
<div class="text">
	<div class="row">
		<div class="col s12 m6 l4">
			<h3>Soci</h3>
			<div class="card hoverable">
				<a href="https://drive.google.com/file/d/10KW1IdHHqNT9Nyg6v4yjQB3Ix3p-XqgC" target="_blank"
					class="card-link">
					<div class="card-content">
						<span class="card-title"><i class="fas fa-file-alt"></i> Regolamento quote</span>
						<p>Stabilisce il procedimento di associazione, le categorie di soci e le quote associative.</p>
					</div>
				</a>
			</div>
			<div class="card hoverable">
				<a href="https://drive.google.com/file/d/1U-EXCrkFgYvPk4oxofmpsCZT03mDWjQT" target="_blank"
					class="card-link">
					<div class="card-content">
						<span class="card-title"><i class="fas fa-file-alt"></i> Regolamento probiviri</span>
						<p>Disciplina il Collegio dei Probiviri, l'organo di garanzia e tutela dell'associazione.</p>
					</div>
				</a>
			</div>
			<div class="card hoverable">
				<a href="https://drive.google.com/file/d/1Gppp2IAglzp_QuyIYDNpYGGBzOyXpTcC" target="_blank"
					class="card-link">
					<div class="card-content">
						<span class="card-title"><i class="fas fa-file-alt"></i> Regolamento rimborsi</span>
						<p>Disciplina le richieste di trasferta e di rimborso nell'ambito delle attività approvate.</p>
					</div>
				</a>
				<div class="card-actions">
					<a href="https://drive.google.com/file/d/1SpBqj9gHsUV40YJjgi333Sqedr1oYBp8" target="_blank"
						class="action-link">
						Allegato A: richiesta trasferta
					</a>
					<a href="https://drive.google.com/file/d/1FFdkwP9WQ6z-zkuNZDs7juxFvQWY4jOR" target="_blank"
						class="action-link">
						Allegato B: richiesta rimborso
					</a>
				</div>
			</div>
		</div>
		<div class="col s12 m6 l4">
			<h3>Enti e aziende</h3>
			<div class="card hoverable">
				<a href="https://drive.google.com/file/d/1DDK-n4mRvQn9bjEeRSN9nL-Aty1ZudnV" target="_blank"
					class="card-link">
					<div class="card-content">
						<span class="card-title"><i class="fas fa-file-alt"></i> Regolamento affiliazione</span>
						<p>Permette l'affiliazione da parte di enti, PA, aziende; disciplina sponsorship e partnership.
						</p>
					</div>
				</a>
			</div>
			<div class="card hoverable">
				<a href="https://drive.google.com/file/d/1snheP5hskZ8DJ5irzzl0-zHCwVMSmvrV" target="_blank"
					class="card-link">
					<div class="card-content">
						<span class="card-title"><i class="fas fa-file-alt"></i> Regolamento partnership</span>
						<p>Specifico per progetti inerenti la crittografia e le sue applicazioni.</p>
					</div>
				</a>
			</div>
			<h3>Attività scientifica</h3>
			<div class="card hoverable">
				<a href="https://drive.google.com/file/d/16mOhRdstoWB5sT0qPSqU2ojoxhnzO-_g" target="_blank"
					class="card-link">
					<div class="card-content">
						<span class="card-title"><i class="fas fa-file-alt"></i> Regolamento scientifico</span>
						<p>Disciplina il Comitato Scientifico, il congresso, convegni, e altre attività scientifiche.
						</p>
					</div>
				</a>
			</div>
		</div>
	</div>
</div>